import React, { useState } from 'react';
import {Link, Navigate} from 'react-router-dom';
import Navbar from '../Components/Navbar/navbar.jsx';
import './novocliente.css';
import firebase from '../Config/firebase';
import { collection, addDoc, getFirestore } from 'firebase/firestore';

function NovoCliente(){
    const [nome,setNome] = useState('');
    const [email,setEmail] = useState('');
    const [fone,setFone] = useState('');
    const [siape,setSiape] = useState('');
    const [cpf,setCpf] = useState('');
    const [processo,setProcesso] = useState('');
    const [valor,setValor] = useState('');
    const [mensagem,setMensagem] = useState('');
    const [sucesso,setSucesso] = useState('N');
    const db = getFirestore();
   
     function CadastrarCliente(){
      if (nome.length === 0){
          setMensagem('Informe o nome');
      }
      else{
          const docRef = addDoc(collection(db, "clientes"), {
            nome: nome,
            siape: siape,
            cpf: cpf,
            processo: processo,
            valor: valor
          })
          .then((docRef) => {
            setMensagem('');
            setSucesso('S');
          })
          .catch((error) => {
            setMensagem(error);
            setSucesso('N');
          })
    }
    }

    return <div>
        <Navbar/>
        <div className="container-fuid titulo">
          <div className="offset-lg-3 col-lg-6">  
            <h1>Novo Sindicalizado</h1>
            <form>
                <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">Nome</label>
                    <input onChange={(e) => setNome(e.target.value)} type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label">SIAPE</label>
                    <input onChange={(e) => setSiape(e.target.value)} type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label">CPF</label>
                    <input onChange={(e) => setCpf(e.target.value)} type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label">Processo</label>
                    <input onChange={(e) => setProcesso(e.target.value)} type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label">Valor</label>
                    <input onChange={(e) => setValor(e.target.value)} type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                </div>
                <div className = "text-center">
                  <Link to="/app/home" className="btn btn-outline-primary btn-nocl">Cancelar</Link>
                  <button onClick={CadastrarCliente} type="button" className="btn btn-primary btn-nocl">Salvar</button>
                </div>
                {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                {sucesso==='S' ? <Navigate to='/app/home' /> : null}
            </form>
          </div>
        </div>  
    </div>
  }
  export default NovoCliente;